import { BookListTab } from './BookListTab'
import { withBookListTab } from './withBookListTab'

const ConnectedBookListTab = withBookListTab(BookListTab)
export { ConnectedBookListTab as BookListTab }
